import { getMenuViewportReference } from 'bento-ordering/menus/utils/index';

const MARGIN_OFFSET = 80;

/**
 * A util that takes in an array of menu label references and split it into
 * two separate arrays of menu sections where the rendered menu section bar width
 * no longer exceed the rendered width of the view port width.
 * @param {*} menuSectionBarRef React Ref or dom element reference to the menu section bar
 * @param {*} viewportRef React Ref or dom element to the viewport
 * @param {*} menuSections menu section objects
 */
export const getSectionLabelsForMenuBarAndDropdown = (
  menuSections,
  storeSectionItemWidths
) => {
  const allowableWidth = getMenuViewportReference().clientWidth - MARGIN_OFFSET;

  const menuSectionItemsGroupedIntoViewableGroups = [];
  const moreDropdownMenuSectionItems = [];

  let sectionBarWidthSoFar = 0;
  menuSections.forEach((section, index) => {
    const currentSectionItemWidth = storeSectionItemWidths[index];
    sectionBarWidthSoFar += currentSectionItemWidth;

    if (sectionBarWidthSoFar >= allowableWidth) {
      moreDropdownMenuSectionItems.push(section);
    }
  });

  function doMoreMenuSectionsRemain(index, count) {
    return index + 1 < count;
  }

  sectionBarWidthSoFar = 0;
  menuSectionItemsGroupedIntoViewableGroups.push([]);
  let groupIndex = 0;
  menuSections.forEach((section, index) => {
    const currentSectionItemWidth = storeSectionItemWidths[index];
    sectionBarWidthSoFar += currentSectionItemWidth;

    if (sectionBarWidthSoFar < allowableWidth) {
      menuSectionItemsGroupedIntoViewableGroups[groupIndex].push(section);
    } else {
      menuSectionItemsGroupedIntoViewableGroups.push([section]);
      if (doMoreMenuSectionsRemain(index, menuSections.length)) {
        sectionBarWidthSoFar = currentSectionItemWidth;
        groupIndex += 1;
      }
    }
  });

  return {
    menuSectionItemsGroupedIntoViewableGroups,
    moreDropdownMenuSectionItems
  };
};
